/* eslint-disable indent */
import { useState } from 'react'
import Table from 'react-bootstrap/Table'

const TeamPlayerSorter = ({ players, setPlayers }) => {
  const [sortBy, setSortBy] = useState('age') // Oletuksena lajitellaan iän mukaan
  const [sortOrder, setSortOrder] = useState('asc') // Oletuksena nouseva järjestys

  const skills = [
    { key: 'age', label: 'Ikä' },
    { key: 'keeperSkill', label: 'Maalivahti' },
    { key: 'defenderSkill', label: 'Puolustus' },
    { key: 'playmakerSkill', label: 'Pelinrakennus' },
    { key: 'wingerSkill', label: 'Laituri' },
    { key: 'passingSkill', label: 'Syöttäminen' },
    { key: 'scorerSkill', label: 'Maalinteko' },
    { key: 'setPiecesSkill', label: 'Erikoistilanteet' },
  ]

  const handleSortChange = criteria => {
    const newSortOrder =
      sortBy === criteria && sortOrder === 'asc' ? 'desc' : 'asc'
    setSortBy(criteria)
    setSortOrder(newSortOrder)

    const sorted = [...players].sort((b, a) => {
      const getValue = player =>
        criteria === 'age' ? player.age : player.playerSkills[criteria]
      const compareValue = getValue(a) - getValue(b)
      return newSortOrder === 'asc' ? compareValue : -compareValue
    })

    setPlayers(sorted) // Päivitetään järjestetyt pelaajat suoraan
  }

  return (
    <Table striped bordered hover variant="dark" size="sm">
      <thead>
        <tr>
          {skills.map(skill => (
            <th
              key={skill.key}
              onClick={() => handleSortChange(skill.key)}
              style={{ cursor: 'pointer' }}
            >
              {skill.label}{' '}
              {sortBy === skill.key && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
          ))}
        </tr>
      </thead>
    </Table>
  )
}

export default TeamPlayerSorter
